import { ACTIONS } from "../constants/actions";

export default (state = null, action) => {
  switch (action.type) {
    case ACTIONS.SET_USER:
      if(action.payload===null) return null;
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}